import React, { useState } from "react";
import MultiVoucherForm from "./MV-form";
import {
  Avatar,
  colors,
  Container,
  Grid,
  makeStyles,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import { useStylesHed } from "../../../../../St/comps/UseStyle";
import useFormDataCRUD from "../../../../../components/Hooks/useEDSCURD";
import EReceiptAPI from "../../../../../api/EReceipt";
import {
  MRVdefaultValues,
  ReFormatingData,
} from "../../../../../services/multi-receipt-services";
import MReceiptVoucherAppBar from "./MReceiptVoucher-AppBar";
import { getAccountOmlat } from "../../../../../services/omlat-services";
import MultiSub from "./multi-sub/multiSub";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { sto } from "../../../../../Context/InshData";
import { useStylesLbl } from "../../../../../St/Reports/UseStyle";
import { GetEmpFromOptions, isMobileDevice, useStylesSand } from "../external-exchange-voucher/EExchangeVoucher";
import { addArchaiveFile, handleDownloadFiles } from "../../../../Invs/BackEnd/components/SearchItemsFunction";

export default function MultiVoucher(props) {
  const { AutoOptions, prmis, fetchURL, isReceipt, isDialog, item, onClose,
    AutoOptionsB,
    branch,
    setBranch,
  } =
    props;
  const [branchT, setBranchT] = useState(sto.branchi);
  const [optionsStocks, setOptionsStocks] = useState(AutoOptions?.Stocks);

  const StockOmlat = getAccountOmlat(
    AutoOptions.Stocks[0].acc_omlat ?? 1,
    AutoOptions.omlats
  );
  const BankOmlat = getAccountOmlat(
    AutoOptions.Banks[0].acc_omlat ?? 1,
    AutoOptions.omlats
  );

  const defaultV = isDialog
    ? ReFormatingData(item, AutoOptions)
    : {
      ...MRVdefaultValues,
      id: AutoOptions.other.lastid,
      emp: GetEmpFromOptions(sto.empi, AutoOptions.Users),
      stock: AutoOptions.Stocks[0],
      bank: AutoOptions.Banks[0],
      rows: [],
      stock_omlat: StockOmlat ?? AutoOptions.omlats,
      stock_omla: StockOmlat[0] ?? AutoOptions.omlats[0],
      bank_omlat: BankOmlat ?? AutoOptions.omlats,
      bank_omla: BankOmlat[0] ?? AutoOptions.omlats[0],
    };

  const {
    onChange,
    submit,
    update,
    remove,
    submitting,
    errorMessage,
    onShow,
    onEnd,
    object,
    formType,
    getRow
  } = useFormDataCRUD(
    isReceipt ? EReceiptAPI.createM : EReceiptAPI.createMS,
    isReceipt ? EReceiptAPI.updateM : EReceiptAPI.updateMS,
    isReceipt ? EReceiptAPI.removeM : EReceiptAPI.removeMS,
    undefined,
    defaultV,
    null,
    () => {
      if (isDialog) onClose(true);
      else fetchURL();
    },
    isDialog ? "edit" : "new",
    isReceipt ? EReceiptAPI.GetRowM : EReceiptAPI.GetRowMS,
  );

  const changAutoStocks = async (newValue) => {
    const accOmlat = getAccountOmlat(newValue.acc_omlat, AutoOptions.omlats);
    let nObject = {
      ...object,
      stock: newValue,
      stock_omlat: accOmlat,
      stock_omla: accOmlat[0],
    };
    onShow(nObject, formType);
  };

  const changAutoBanks = async (newValue) => {
    const accOmlat = getAccountOmlat(newValue.acc_omlat, AutoOptions.omlats);
    let nObject = {
      ...object,
      bank: newValue,
      bank_omlat: accOmlat,
      bank_omla: accOmlat[0],
    };
    onShow(nObject, formType);
  };

  const { t } = useTranslation(["forms", "translation"]);

  const classes = useStylesSand();
  const clashd = useStylesHed();
  const total = object?.rows?.reduce((a, v) => (a = a + v.credit), 0);
  const totalvat = object?.rows?.reduce((a, v) => (a = a + parseFloat(v?.taxval)), 0);
  const net_amount = object?.rows?.reduce((a, v) => (a = a + parseFloat(v?.netamount) ?? 0), 0);

  const [file, setFile] = useState(null);
  const addArchaive = async (data) => {
    let type = !isReceipt ? "MultiSarf" : "MultiQabd";
    let fileName = type + object.id + branch.id;
    addArchaiveFile(file, fileName);
  };
  const handleDownload = async () => {
    try {
      let type = !isReceipt ? "MultiSarf" : "MultiQabd";
      let fileName = type + object.id + branch.id;
      await handleDownloadFiles(fileName);
    } catch (error) {
    }
  };

  const accounts = AutoOptions?.Customers;
  const claslbl = useStylesLbl();

  return (
    <>
      <div
        className={classes.rootMu}
        style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
      >
        <Grid
          item
          container
          justifyContent="space-evenly"
          spacing={0}
          className={clashd.rootHd}
          style={{
            padding: isMobileDevice ? "10px" : "15px",
            color: colors.grey[900],
            backgroundColor: colors.grey[400],
          }}
        >
          <Grid item>
            <Typography variant={"h4"} component="h2" style={{}}>
              {isReceipt
                ? t("translation:mult-receipt")
                : t("translation:mult-exchange")}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <AttachMoneyIcon className={classes.icon} />
            </Avatar>
          </Grid>
        </Grid>
        <Typography
          component="div"
          style={{
            direction: i18next.language == "ar" ? "rtl" : "ltr",
            marginTop: "0px",
            borderRightColor: colors.grey[400],
            borderRightWidth: "10px",
            borderRightStyle: "solid",
          }}
        >
          <Grid container justifyContent="center" spacing={0}>
            <Grid item lg={5} md={5} sm={12} xs={12}>
              <Container
                component={Paper}
                maxWidth={true}
                style={{
                  padding: isMobileDevice ? "6px" : "25px",
                  borderBottomWidth: "0px",
                  borderRightColor: colors.grey[200],
                  borderRightWidth: "0px",
                  borderRightStyle: "solid",
                }}
              >
                <MultiVoucherForm
                  {...{
                    ...props,
                    object,
                    formType,
                    changAutoBanks,
                    changAutoStocks,
                    onChange,
                    onShow,
                    AutoOptionsB,
                    branch,
                    setBranch,
                    branchT,
                    optionsStocks,
                    isMobileDevice,
                    handleDownload,
                    setFile,
                    prmis
                  }}
                />
                <br />
              </Container>
            </Grid>
            <Grid item lg={7} md={7} sm={12} xs={12}>
              <Container
                component={Paper}
                maxWidth={true}
                style={{
                  padding: isMobileDevice ? "7px" : "20px",
                  border: "0px",
                  borderColor: colors.grey[400],
                  borderRightWidth: i18next.language == "ar" ? "5px" : "0px",
                  borderLeftWidth: i18next.language == "ar" ? "0px" : "5px",
                  borderStyle: "solid",
                }}
              >
                <MultiSub
                  {...{
                    ...props,
                    object,
                    accounts: accounts,
                    onShow,
                    formType,
                    onChange,
                    isReceipt,
                    prmis
                  }}
                />
              </Container>
            </Grid>
            <Grid item container lg={12} md={12} sm={12} sx={12}>
              <Container
                maxWidth={true}
                style={{ backgroundColor: colors.grey[400], padding: 20 }}
              >
                <Grid
                  item
                  container
                  lg={12}
                  md={12}
                  sm={12}
                  sx={12}
                  spacing={3}
                  style={{ backgroundColor: "#fff" }}
                >
                  <Grid item lg={3} md={3} sm={3} xs={6}>
                    <TextField
                      type="number"
                      fullWidth
                      variant="outlined"
                      size="small"
                      id="total"
                      label={t("froms:total")}
                      name="total"
                      value={total}
                      InputLabelProps={{ className: claslbl.clrBlackLblS, shrink: true }}
                      InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                    // disabled={true}
                    />
                  </Grid>
                  {totalvat > 0 ? null :
                    (
                      <Grid item lg={3} md={3} sm={3} xs={6}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          id="taxperc"
                          label={t("forms:value-tax") + "%"}
                          type="number"
                          disabled={totalvat > 0 ? true : false}
                          // InputLabelProps={{ shrink: true }}
                          InputLabelProps={{ className: claslbl.clrBlackLblS, shrink: true }}
                          InputProps={{ className: claslbl.clrBlackTxt }}
                          name="taxperc"
                          value={object.taxperc}
                          onChange={(e) => {
                            let nObj = {
                              ...object,
                              taxperc: e.target.value,
                              taxval: total / e.target.value,
                            };
                            onShow(nObj, "new");
                          }}
                        />
                      </Grid>
                    )}

                  <Grid item lg={3} md={3} sm={3} xs={6}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      id="taxperc"
                      label={t("forms:vat_total")}
                      type="number"
                      InputLabelProps={{ className: claslbl.clrBlackLblS, shrink: true }}
                      InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                      name="taxperc"
                      value={totalvat > 0 ? parseFloat(totalvat) : total * (object.taxperc / 100)}
                    // disabled={true}
                    />
                  </Grid>
                  <Grid item lg={3} md={3} sm={3} xs={6}>
                    <TextField
                      type="number"
                      fullWidth
                      variant="outlined"
                      size="small"
                      id="total"
                      label={t("net")}
                      name="total"
                      value={totalvat > 0 ? parseFloat(net_amount) ?? 0 : parseFloat(total + (total * (object.taxperc / 100))).toFixed(2)}
                      InputLabelProps={{ className: claslbl.clrBlackLblS, shrink: true }}
                      InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                    // disabled={true}
                    />
                  </Grid>
                </Grid>
              </Container>
            </Grid>
          </Grid>
        </Typography>
      </div>
      <MReceiptVoucherAppBar
        {...{
          URL: isReceipt ? EReceiptAPI.MURL : EReceiptAPI.MSURL,
          prmis,
          ...props,
          onChange,
          submit,
          update,
          defaultV,
          remove,
          submitting,
          errorMessage,
          onShow,
          onEnd,
          object,
          formType,
          getRow,
          AutoOptions,
          branch,
          branchT,
          setBranchT,
          AutoOptionsB,
          setOptionsStocks,
          isReceipt,
          addArchaive,
          file,
        }}
      />
    </>
  );
}
